module.exports = __webpack_public_path__ + "static/media/german-language-course-near-me.f6de398b.jpeg";